/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';

import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { meetingSimpleSelectors } from '../../../app/resource/meeting-simple/meeting-simple.selectors';
import { IMeetingSimple } from '../../../app/resource/meeting-simple/meeting-simple.types';
import { sessionSelectors } from '../../../app/resource/session/session.selectors';
import { ISession } from '../../../app/resource/session/session.types';

import { useSelectWithParams } from '../../../utils/selector.utils';

import { ConnectedDialog } from '../ConnectedDialog';
import { MeetingAttendees } from './MeetingAttendees';

import { IMeetingAttendeesDialogProps } from './types';

export const MeetingAttendeesDialog: FunctionComponent = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'meetingAttendeesDialog',
  ) as IMeetingAttendeesDialogProps;

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingAttendeesDialog'));
  }, [dispatch]);

  const session = useSelectWithParams(sessionSelectors.selectResourceById, props?.sessionId) as ISession;
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, props?.meetingId) as IMeetingSimple;

  const onlineMembers = session?.meetingMembers ? session.meetingMembers : [];
  const offlineMembers = meeting
    ? Array.from(new Set([...meeting.administratorIds, ...meeting.shareWithIds])).filter(
        (id) => !onlineMembers.includes(id),
      )
    : [];
  return (
    <ConnectedDialog dialogKey="meetingAttendeesDialog">
      <div className="popup new_todo_popup" style={{ display: 'block' }}>
        <div className="panel" style={{ minWidth: '520px' }}>
          <div className="panel-header flex jcsb">
            <h3 style={{ fontSize: '16px' }}>Active meeting attendees</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body p-2">
            <div className="cards-container" style={{ display: 'flex' }}>
              {onlineMembers?.length + offlineMembers.length > 0 && (
                <MeetingAttendees userIds={onlineMembers} isOnline={true} />
              )}

              <MeetingAttendees userIds={offlineMembers} isOnline={false} />
            </div>
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
